import React from 'react';


const ConnectionStatus = ({ isConnected, quality }) => {
  const getQualityColor = () => {
    switch (quality) {
      case 'excellent':
        return 'text-emerald-400';
      case 'good':
        return 'text-green-400';
      case 'fair':
        return 'text-yellow-400';
      case 'poor':
        return 'text-red-400';
      default:
        return 'text-gray-400';
    }
  };

  const getQualityBars = () => {
    const bars = {
      excellent: 4,
      good: 3,
      fair: 2,
      poor: 1
    };
    return bars?.[quality] || 0;
  };

  const activeBars = getQualityBars();

  return (
    <div className="flex items-center gap-3">
      {/* Connection Status */}
      <div className="flex items-center gap-2">
        <div
          className={`w-2 h-2 rounded-full ${
            isConnected ? 'bg-emerald-400' : 'bg-gray-400'
          } animate-pulse`}
        />
        <span className="text-gray-300 text-sm hidden md:block">
          {isConnected ? 'Connected' : 'Connecting...'}
        </span>
      </div>
      {/* Quality Indicator */}
      {isConnected && (
        <div className="flex items-center gap-2 px-3 py-1.5 bg-[#374151] rounded-lg">
          <div className="flex items-end gap-0.5 h-4">
            {[1, 2, 3, 4]?.map((bar) => (
              <div
                key={bar}
                className={`w-1 rounded-sm transition-all ${
                  bar <= activeBars ? getQualityColor() : 'bg-gray-600'
                }`}
                style={{ height: `${bar * 25}%` }}
              />
            ))}
          </div>
          <span className={`text-xs font-medium ${getQualityColor()} hidden sm:block capitalize`}>
            {quality}
          </span>
        </div>
      )}
    </div>
  );
};

export default ConnectionStatus;